import { useSelector } from "react-redux";
import RulesListandDetails from "./RulesListandDetails";
import UploadFileButton from "./UploadFileButton";
import {
  getOutputColumnsData,
  getInputColumnsData,
  getInputFile,
} from "../store/workspaceSlice";
import ViewInputFile from "./ViewInputFile";
import DraggableMappings from "./DragableMappings";
import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import ViewFileSettings from "./ViewFileSettings";

const ViewRules = () => {
  // Use the selectors to access state
  const outputColumns = useSelector(getOutputColumnsData);
  const inputColumns = useSelector(getInputColumnsData);
  // const inputFiles = useSelector((state) => state.workspace.inputFiles);  // get input files
  const inputFile = useSelector(getInputFile); // get input files

  const initialAccordionState = {
    input: false,
    output: false,
    rules: false,
    fileSettings: false,
  };
  const [isOpen, setIsOpen] = useState(initialAccordionState);
  // AntDesign Modal to view file data
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const toggleAccordion = (state) => {
    setIsOpen((prev) => {
      return { ...prev, [state]: !prev[state] };
    });
  };
  return (
    // Right Most Column (file / input / output / rules )
    <div className="p-2 h-screen overflow-auto">
      {/* View input file button in if there is any input file */}
      <UploadFileButton />
      {inputFile.length > 0 && (
        <div
          className=" bg-gray-50 cursor-pointer p-2 mb-2 rounded hover:bg-gray-300 border border-gray-400 shadow hover:outline-none text-red-500 font-medium"
          onClick={showModal}
        >
          {/* <Button type="primary" onClick={showModal}> */}
          Preview File
          {/* </Button> */}
        </div>
      )}
      {/* Input Columns data */}
      <div className="bg-gray-50 rounded-md shadow mb-2">
        <div
          className="flex justify-between items-center cursor-pointer p-2 rounded hover:bg-gray-300 border border-gray-400 shadow hover:outline-none text-gray-500"
          onClick={() => {
            (inputColumns.length || isOpen.input) && toggleAccordion("input");
          }}
        >
          <div className="text-gray-500">{inputColumns.length || ""}</div>
          <h2 className="text-red-600 font-medium">Input Columns</h2>

          {isOpen.input ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <ul
          className={`space-y-2 bg-gray-50 rounded-md ${
            isOpen.input ? "max-h-60 py-4" : "max-h-0"
          }  overflow-y-auto transition-all duration-300`}
        >
          {/* Map input column list */}
          {inputColumns.map((column) => {
            const index = column.inColChr;
            return (
              <RulesListandDetails
                column={column}
                index={index}
                type="input"
                key={index}
              />
            );
          })}
        </ul>
      </div>
      {/* output Columns data */}
      <div className="bg-gray-50 rounded-md shadow mb-2">
        <div
          className="flex justify-between items-center cursor-pointer p-2 rounded hover:bg-gray-300 border border-gray-400 shadow hover:outline-none text-gray-500"
          onClick={() => {
            (outputColumns.length || isOpen.output) &&
              toggleAccordion("output");
          }}
        >
          <div>{outputColumns.length || ""}</div>
          <h2 className="text-red-600 font-medium">Output Columns</h2>
          {isOpen.output ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <ul
          className={`space-y-2 bg-gray-50 rounded-md  overflow-y-auto ${
            isOpen.output ? "max-h-60 py-4" : "max-h-0"
          }  transition-all duration-300`}
        >
          {outputColumns.map((column) => {
            const index = column.outColChr;
            return (
              <RulesListandDetails
                column={column}
                index={index}
                type="output"
                key={index}
              />
            );
          })}
        </ul>
      </div>
      {/* View Rules Sortable */}
      <DraggableMappings />
      {/* only show this file settings component if we have file settings */}
      <ViewFileSettings isOpen={isOpen} toggleAccordion={toggleAccordion} />
      {/* View input file in modal */}
      <ViewInputFile
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        fileData={inputFile}
      />
    </div>
  );
};

export default ViewRules;
